import { Breakpoints, Text, styled } from '@volkswagen-onehub/components-core';
import { CTA } from '@tribal-worldwide-london/ui-component-library-vwg';
import zIndex from '@/modules/constants/zIndex';
import { VWImage } from '@/modules/components';

export const HeaderWrapper = styled.div(
  ({ theme }) => `
  position: relative;
  padding-top: ${theme.size.dynamic0200};
  overflow: hidden;
  z-index: 1;
`
);

export const Background = styled.div(
  ({ theme }) => `
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 30%;
  background-blend-mode: multiply;
  background: linear-gradient(0deg, #E8E3D9 0.11%, rgba(232, 227, 217, 0) 75.62%);

  z-index: ${zIndex.BACKGROUND};

  @media (min-width: ${Breakpoints.b960}px) {
    height: 75%;
  }
`
);

export const HeaderBackgroundTextWrapper = styled.div`
  position: absolute;
  bottom: -25%;
  z-index: ${zIndex.BACKGROUND};

  @media (min-width: ${Breakpoints.b960}px) {
    left: 15%;
  }
`;

export const Title = styled(Text)(
  ({ theme }) => `
  text-align: center;
  padding-bottom: ${theme.size.static500};
  @media (min-width: ${Breakpoints.b960}px) {
    text-align: left;
    max-width: 600px;
    padding-bottom:  ${theme.size.static520};
  }
`
);

interface VehicleButtonCarouselWrapperProps {
  vehiclesLength: number;
}

export const VehicleButtonCarouselWrapper =
  styled.div<VehicleButtonCarouselWrapperProps>(
    ({ theme, vehiclesLength }) => `
    display: flex;
    flex-direction: column;
    margin-top: ${theme.size.static400};

    @media (min-width: ${Breakpoints.b960}px) {
      align-items: end;
      margin-top: 0;
      max-width: ${vehiclesLength * 175}px;
    }
  `
  );

export const StyledHeroImage = styled(VWImage)(
  ({ theme }) => `
  margin-bottom: ${theme.size.static500};
  z-index: ${zIndex.BACKGROUND};
  transform: translateY(-10%) scale(1.4);

  @media (min-width: ${Breakpoints.b960}px) {
    max-width: 60%;
    margin: 0 auto;
    order: 2;
  }
`
);

export const TitleAndVehicleCarouselWrapper = styled.div(
  ({ theme }) => `
  display: flex;
  justify-content: space-between;

  @media (min-width: ${Breakpoints.b960}px) {
    gap: ${theme.size.static500};
  }
`
);

export const CarAndGalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;

  button:focus,
  button:focus-visible {
    outline: none;
  } 

  @media (min-width: ${Breakpoints.b960}px) {
    flex-direction: row;
  }
`;

export const CompareCTA = styled(CTA)(
  ({ theme }) => `
    margin-top: ${theme.size.static350};
`
);
